/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

export const TIME_GRAINS = {
  HOUR: 'hour',
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  QUARTER: 'quarter',
  YEAR: 'year',
};

export const MONITORING_DIALOGS = {
  DASHBOARD_NOT_READY_MODAL: 'DASHBOARD_NOT_READY_MODAL',
  UPDATE_DASHBOARD_MODAL: 'UPDATE_DASHBOARD_MODAL',
  PIN_DASHBOARD_MODAL: 'PIN_DASHBOARD_MODAL',
};

export const DASHBOARD_DATA_TYPES = {
  ALERT: 'alert',
};

export const CUSTOM_CARD_TYPES = {
  ALERT: 'ALERT',
  THIRD_PARTY: 'THIRD_PARTY',
};

/*
 * Interval constants
 */
export const INTERVALS = {
  MINUTE: 'minute',
  HOUR: 'hour',
  DAY: 'day',
  WEEK: 'week',
  QUARTER: 'quarter',
  MONTH: 'month',
  YEAR: 'year',
};

/*
 * Time constants
 */
export const TIMES = {
  ONE_YEAR: 365,
  HALF_A_YEAR: 182,
  HALF_A_DAY_IN_MINS: 720,
  ONE_QTR: 90,
  ONE_MONTH: 30,
  ONE_DAY_IN_MINS: 1440,
  HALF_A_DAY: 0.5,
};

export const TIME_FREQUENCY_TIME_GRAIN_MAP = {
  Hourly: 'hour',
  Daily: 'day',
  Weekly: 'week',
  Monthly: 'month',
};
